<template>
    <div id="service" class="service">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 offset-sm-0">
                    <h2>Service</h2>
                </div>
            </div>
            <div class="row">

                <div class="col-md-4">
                    <ul class="nav nav-tabs service__tabs-nav" id="service__tabs" role="tablist">
                        <li class="nav-item" v-for="(value, key, index) in services">
                            <a class="nav-link" data-toggle="tab" :href="value.link" role="tab" aria-controls="settings">{{ value.titel }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6 offset-md-1">
                    <div class="tab-content service__tabs-content">
                        <div class="tab-pane" :id="key" role="tabpanel" v-for="(value, key, index) in services" v-html="value.beschreibung">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/wp/v2/pages/11'
    });

    export default {
        name: 'Service',
        data(){
            return {
                services: [],
            };
        },
        mounted(){
            ax.get().then(response => {
                this.services = response.data.acf.services;
            });
        }
    }

</script>


<style lang="scss">
    @import "../assets/styles/components/service.scss";
</style>